export default __webpack_public_path__ + "static/media/pregnancy-care.a69b6c94.svg";